import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import main from './store/main'
import repair from './store/repair'

export default new Vuex.Store({
  modules: { 
    main,
    repair
  }
})
